import { Navigate } from 'react-router-dom';

import { ROUTES } from '@/config/routes';
import { tokenStorage } from '@/shared/auth/tokenStorage';

/**
 * What `/` does: the dashboard when signed in, the sign-in page when not.
 *
 * <h2>Why it is not a page</h2>
 *
 * It used to render the marketing landing page, so somebody already signed in who
 * typed the bare domain landed on marketing copy and had to navigate into the
 * application again. The landing page is gone — the marketing site lives at
 * xtremand.com — and nothing routes here as a destination any more.
 *
 * <h2>No loading branch, and that is a property of this application</h2>
 *
 * The equivalent in the application being replaced has to render nothing for a
 * tick, because its auth provider starts signed-out and resolves the real answer
 * asynchronously — redirecting immediately would flash the login form at every
 * signed-in visitor and leave a real entry in their history.
 *
 * <p>Here the token is read synchronously from storage, the same call
 * {@link ProtectedRoute} makes for the same reason, so the answer is already
 * correct on the first render and there is no tick to cover.
 *
 * <p>Like that check, this is convenience rather than security: it proves a token
 * exists, not that it is valid. Somebody who forces their way to the dashboard
 * with a made-up token finds every request refused and the screen empty.
 */
export function RootRedirect() {
  return <Navigate to={tokenStorage.accessToken() ? ROUTES.dashboard : ROUTES.signIn} replace />;
}
